import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Divider, Button, Space, List, Spin, Card, Modal, message, Form , Input, Select, Badge, Tag } from 'antd';
import AppContext from "../AppContext"
import { ReloadOutlined, PlusCircleTwoTone } from "@ant-design/icons";
import { BRANCH_STATUS } from '../../Models/shared/master';
import { onCreateBranch, onGetBranch, onEditBranch } from '../../Controller/Management/BranchManagement';
import T_Error from "../404";

const { Meta }      = Card;
const { Option }    = Select;

export default function BranchManagement(prop){
    //===== VARIABLE ====
    const global                            = useContext(AppContext)
    const userid                            = global.UserIdentity.userid;
    const [branchlist, setBranchList]       = useState([]);
    const [btndisable, setBtnDisable]       = useState(false);
    const [loading, setLoading]             = useState(false);
    const [branchform]                      = Form.useForm();
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance

    //======= MODAL ========
    const [isModalVisible, setIsModalVisible]   = useState("");
    const [modalTitle, setModalTitle]           = useState("");
    const [action, setAction]                   = useState("");

    //===== USE EFFECT ========
    useEffect(() => {
        onRefresh();
    },[]);


    //===== FUNCTION =====
    const onRefresh = () => {
        setLoading(true);
        onGetBranch({
            userid  : userid
        })
        .then(val => {
            setBranchList(val.data);
            setLoading(false);
            setBtnDisable(false);
            return val;
        })
        .catch(err => {
            message.error(err.msg);
            setIsMaintenance(true);
        });
    }

    //20210727 add refresh all windows
    const onReload = () => {
        setBtnDisable(true);
        window.location.reload();
    }

    const showModal = (modalAction) => {
        // setModalAction(modalAction);
        switch (modalAction) {
            case "createbranch":
                setAction("create");
                setModalTitle(`New Branch`);
                setIsModalVisible(true);
                break;
            case "editbranch":
                setAction("edit");
                setModalTitle("Edit Branch");
                setIsModalVisible(true);
                break;
            case "deletebranch":
                setAction("delete");
                setModalTitle("Delete Branch");
                setIsModalVisible(true);
                break;
            default:
                message.error("No Action required");
                break;
        }
    };

    const onFinish = (data) => {
        switch (action) {
            case 'create':
                return onCreateBranch(data)
                .then(result => {
                    onRefresh();
                    setIsModalVisible(false);
                });
            case "edit":
                data.branchid   = data._id;
                return onEditBranch(data)
                .then(result => {
                    onRefresh();
                    branchform.resetFields()
                    setIsModalVisible(false);
                });
            default:
                message.error("unknown operation, check your interface and try again");
                setIsModalVisible(false);
                return;
        }
    }

    //===== LIST ======
    const renderBranchItem = (data) => {
        if(data._id == undefined){
            return (
                <List.Item
                    visible={"false"}
                >
                    <Card
                        hoverable
                        onClick={() => { showModal("createbranch") }}
                        style={{
                            borderRadius: "10px",
                            display: "flex",
                            minHeight: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "4.2em",
                        }}
                        description={<small>Create User</small>}
                    >
                        <Meta
                            description={
                                <>
                                    <PlusCircleTwoTone twoToneColor={["#00cc00", "rgba(0,0,0,0)"]} />
                                </>}
                        />
                    </Card> 
                </List.Item>
            )
        }
        else{
            return (
                <List.Item
                    visible={"false"}
                >
                    <Badge.Ribbon
                        color={BRANCH_STATUS.filter(st => st.key === data["status"])[0].color}
                        text={BRANCH_STATUS.filter(st => st.key === data["status"])[0].title}
                    >
                        <Card
                            onClick={() => {
                                branchform.setFieldsValue(data);
                                showModal('editbranch');
                            }}
                            hoverable
                            className="list-card-item-BO"
                            style={{
                                minHeight: "100%",
                                borderRadius: "10px",
                                textAlign: "center"
                            }}
                        >
                            <Meta
                                title={
                                    <font
                                        className="gradient-text"
                                        style={{
                                            fontSize: '2.50em'

                                        }} size="large">
                                        {data["name"]}
                                    </font>
                                }
                                description={<>
                                    <Row justify="center">
                                        <Tag color="geekblue">
                                            {data["country"]}
                                        </Tag>
                                        <Tag color="geekblue">
                                            {data["bip"]}
                                        </Tag>
                                    </Row>
                                </>}
                            />
                        </Card>
                    </Badge.Ribbon>
                </List.Item>
            )
        }
        
    }

    //==== PROPS ====
    const listProps = {
        loading     : loading,
        dataSource  : userid == "root" ? [{ "branchid": null }, ...branchlist] : [...branchlist],
        // dataSource  : [{ "branchid": null }, ...branchlist],
        renderItem  : renderBranchItem,
        grid        : { gutter: 16, xs: 2, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 }
    }

    //====== FORM ========
    const onBranchForm = () => {
        return (
            <>
                <Row justify="start">
                    <Divider>{prop.title ?? "."}</Divider>
                </Row>            
                {/* HEADER */}
                {/* BODY */}
                <Row>
                    <Col span={24}>
                        <div style={{float:"right"}}>
                            <Space size={2}>
                                <Button onClick={onReload}>{ btndisable ?  <Spin /> : <ReloadOutlined />}</Button>
                            </Space>
                        </div>

                    </Col>
                </Row>
                <Row justify="center" align="middle">
                <Col span={22}>
                    <List {...listProps}></List>
                </Col>
            </Row>
            </>
        )
    }

    const onBranchProfForm = () => {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };

        return (
            <Form form={branchform} onFinish={onFinish} >
                {(action == "create" || action == "edit") ? 
                    <>
                        {/* ID */}
                        <Form.Item name={"_id"} style={{display: "none"}}></Form.Item>
                        {/* BRANCH NAME */}
                        <Form.Item 
                            name={"name"} 
                            label="Branch" 
                            rules={[{ required: true, message: "Branch Name is required" }]}
                            {...formItemLayout}
                        >
                            <Input placeholder="Branch Name" />
                        </Form.Item>
                        {/* COUNTRY */}
                        <Form.Item 
                            name={"country"} 
                            label="Country" 
                            rules={[{ required: true, message: "Country is required" }]}
                            {...formItemLayout}
                        >
                            <Select placeholder="Select Country" showSearch allowClear>
                                <Option value={"MY"}>Malaysia</Option>
                                <Option value={"TH"}>Thailand</Option>
                                <Option value={"KH"}>Cambodia</Option>
                            </Select>
                        </Form.Item>
                        {/* IP */}
                        <Form.Item 
                            name={"bip"} 
                            label="IP" 
                            rules={[{ required: true, message: "IP is required" }]}
                            {...formItemLayout}
                        >
                            <Input placeholder="IP" />
                        </Form.Item>
                    </> 
                    : action == "delete" ?
                    <>
                        <div>Are you sure you want to remove??</div>
                    </>
                    : <></>
                }
            </Form>
        )
    }

    //===== MODAL ========
    const onBranchModalForm = () => {
        return (
            <Modal
                title           ={modalTitle}
                visible         ={isModalVisible}
                destroyOnClose  ={true}
                style           ={{ maxWidth: "80%" }}
                bodyStyle       ={{ overflow: "auto", maxHeight: "70vh"}}
                onOk            ={handleOk}
                onCancel        ={handleCancel}
                okText          ="Submit"
                >
                {onBranchProfForm()}
            </Modal>
        )
    }

    const handleOk = () => {
        branchform.submit();
    }

    const handleCancel = () => {
        branchform.resetFields()
        setAction("")
        setIsModalVisible(false);
    }


    return (
        <>
            {(() => {
                if(isMaintenance){
                    return (<T_Error />)
                }
                else{
                    return (
                        <>
                        {onBranchForm()}
                        {onBranchModalForm()}
                    </>
                    )
                }
            })()}
        </>
    )
}